"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentfulRichText = void 0;
var react_1 = __importDefault(require("react"));
var rich_text_react_renderer_1 = require("@contentful/rich-text-react-renderer");
var ContentfulRichText = function (_a) {
    var nodeOverrides = _a.nodeOverrides, markOverrides = _a.markOverrides, children = _a.children;
    var value = react_1.default.useMemo(function () {
        try {
            var doc = JSON.parse(children);
            return (0, rich_text_react_renderer_1.documentToReactComponents)(doc, {
                renderNode: nodeOverrides,
                renderMark: markOverrides,
            });
        }
        catch (e) {
            console.log(e);
            return null;
        }
    }, [children, nodeOverrides, markOverrides]);
    return react_1.default.createElement(react_1.default.Fragment, null, value);
};
exports.ContentfulRichText = ContentfulRichText;
exports.default = exports.ContentfulRichText;
